module.exports = __webpack_public_path__ + "static/media/stranalytics-logo-color.f7e9f18b.svg";